import type {
  ClientAccessTokenApiGetClientAccessTokenData,
  V1ClientAccessToken,
} from '@blk/aladdin-graph-client-axios-internal/wealth/integrations/client_access_token/v1/client_access_token_api';
import type { CancelToken } from 'axios';
import { awIntegrationsApi } from './Base';

export const BASE_CLIENT_ACCESS_TOKEN_PATH = `/client-access-token/v1/clientAccessToken`;

export type GetClientAccessTokenQueryParams = Partial<ClientAccessTokenApiGetClientAccessTokenData['query']>;

/**
 * New agraph endpoint to replace getSensitveDataOutboundAccessToken
 */
export function getClientAccessToken(params?: GetClientAccessTokenQueryParams, cancelToken?: CancelToken) {
  return awIntegrationsApi.get<V1ClientAccessToken>(BASE_CLIENT_ACCESS_TOKEN_PATH, {
    params,
    cancelToken,
  });
}
